import React from 'react';
import copy from '../global/cms/copy.json';
import MarkdownArea from '../components/widgets/markdown_area_plus';

export const getHTML = title => {
    const matchTitle = copy.fields.filter(field => {
        return field.field_title == title;
    });

    if (matchTitle.length) {
        const textBlock = matchTitle[0].body;

        return <MarkdownArea>{textBlock}</MarkdownArea>;
    } else {
        return (
            <div className="alert alert-warning">no cms match for {title}</div>
        );
    }
};

export const getText = title => {
    const matchTitle = copy.fields.filter(field => {
        return field.field_title == title;
    });

    if (matchTitle.length) {
        const textBlock = matchTitle[0].body;

        return textBlock;
    } else {
        return (
            <div className="alert alert-warning">no cms match for {title}</div>
        );
    }
};
